import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CreateAppointmentForm from './CreateAppointmentForm';
import { getPetSummaryById } from '../../../../redux/actions/petActions';
import ModalPetInfo from '../../Common/ModalPetInfo';
import { useAppointmentLabels } from '../../../App/customize/hooks/useAppointmentLabels';
import { useGetFacilityServices } from '../../../App/customize/hooks/useGetFacilityServices';

const NewAppointmentModal = ({
  isOpen,
  onClose,
  appointmentDate,
  appointmentTime,
  createData,
  handledateChange,
  handleEndDateChange,
  handleTimeChange,
  onChangeSelect,
  handleShareUpdates,
  saveSuccess,
  handleChange,
  reschedule,
  submit,
  petId,
  daycareVisitsCreated,
  title,
  submitLabel,
  submitDisabled = false,
  resetData,
}) => {
  const [pet, setPet] = useState({});
  const labels = useAppointmentLabels();
  const { data: services } = useGetFacilityServices();
  const isBoardingOnly = services?.isBoardingOnly;

  useEffect(() => {
    if (!petId) return;

    async function getPet() {
      const result = await getPetSummaryById(petId);

      setPet(result);
    }

    getPet();
  }, [petId]);

  return (
    <Modal
      isOpen={isOpen}
      size="xl"
      scrollable
      toggle={onClose}
      backdrop="static"
      returnFocusAfterClose={false}
      className="model-form modal-lg patient-tracking-popup create-appointment-child-modal"
    >
      <ModalHeader className="pet-summary-wrapper">
        <ModalPetInfo
          petSummary={pet}
          avatar={pet.image}
          title={title ?? labels.newAppointment}
        />
      </ModalHeader>
      <ModalBody>
        <div style={{ padding: '20px' }}>
          <CreateAppointmentForm
            appointmentDate={appointmentDate}
            appointmentTime={appointmentTime}
            reschedule={reschedule}
            createData={createData}
            handledateChange={handledateChange}
            handleEndDateChange={handleEndDateChange}
            handleTimeChange={handleTimeChange}
            onChangeSelect={onChangeSelect}
            handleShareUpdates={handleShareUpdates}
            viewMode={saveSuccess}
            handleChange={handleChange}
            labels={labels}
            isBoardingOnly={isBoardingOnly}
            portalMenus
            resetData={resetData}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '8px',
              paddingLeft: '15px',
              marginTop: '8px',
            }}
          >
            <button className="btn loyal-btn-clear" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn loyal-btn-save-update"
              onClick={submit}
              disabled={submitDisabled}
            >
              {submitLabel ?? labels.createAppointment}
            </button>
            {daycareVisitsCreated != null && daycareVisitsCreated >= 1 && (
              <span style={{ fontSize: '12px', color: '#999' }}>
                {daycareVisitsCreated === 1
                  ? 'Daycare visit created'
                  : `${daycareVisitsCreated} Daycare visits created`}
              </span>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default NewAppointmentModal;
